var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentfailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 141,
    viewBox: "0 0 126 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.6216,
    cy: 65.5,
    rx: 31,
    ry: 31.5,
    fill: "#D37573"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6963 1.87579C66.5453 -0.473926 80.7819 1.93712 93.085 8.71585C105.388 15.4946 115.032 26.2412 120.444 39.2035C125.857 52.1659 126.719 66.5794 122.889 80.0943C119.059 93.6092 110.765 105.428 99.3568 113.624",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7754 12.7011C32.5443 8.54249 38.9843 5.40525 45.815 3.42615",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0178 117.473C24.638 112.831 17.4454 106.313 12.0022 98.4297C6.55896 90.5464 3.01267 81.511 1.64053 72.0299C0.2684 62.5487 1.10759 52.8787 4.09249 43.7756C7.07739 34.6726 12.1271 26.3832 18.847 19.5554",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0393 137.084L26.3267 140.361L32.1065 120.601",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5451 124.409C64.402 125.985 55.0212 125.478 46.1009 122.927L34.3916 133.262",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7974 120.179C85.4806 121.175 83.1054 122.029 80.6848 122.736",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7033 32.9103C76.4063 34.227 83.3374 38.3795 88.1323 44.5504C92.9272 50.7212 95.2386 58.4634 94.6113 66.253C93.9841 74.0425 90.4637 81.3151 84.7432 86.6392C79.0227 91.9634 71.5164 94.9533 63.7019 95.0205C55.8874 95.0877 48.3309 92.2273 42.5196 87.0023C36.7084 81.7774 33.0635 74.5664 32.3023 66.7888C31.5412 59.0112 33.7191 51.2304 38.4071 44.978C43.0952 38.7256 49.9539 34.4545 57.6331 33.0055",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6468 97.8896C48.5888 96.3464 40.5146 91.2688 35.1997 83.7734C29.8848 76.278 27.7646 66.9786 29.3051 57.9201",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0525 75.4501C93.9196 81.3485 90.227 86.5579 85.3678 90.5238C80.5086 94.4897 74.6649 97.0635 68.4587 97.9712",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9707 49.2843C35.4827 41.6527 41.6475 35.5569 49.3182 32.131C56.9888 28.7051 65.6428 28.1824 73.6699 30.6602C81.6971 33.1381 88.5508 38.4476 92.9557 45.601C97.3607 52.7544 99.017 61.2645 97.6164 69.5478",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6203 65.7862L72.8327 75L74.6216 73.2138L65.4067 64L74.6216 54.7887L72.8352 53L63.6203 62.2138L54.408 53L52.6216 54.7887L61.8339 64L52.6216 73.2113L54.408 75L63.6203 65.7862Z",
    fill: "#263238"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentfailed);
export default __webpack_public_path__ + "static/media/paymentfailed.29e6d5e8c2b1ab10c57a4882edbb2577.svg";
export { ForwardRef as ReactComponent };